import { lazy, Suspense } from "react";

import { Row } from "@tanstack/react-table";

import { DatatableRowData, DatatableRowDataWithCacheKey } from "../datatable-types";

import { DatatableListType } from "./datatable-list";

const LazyList = lazy(() =>
  import("./datatable-list").catch((error) => {
    console.error("Failed to load datatable-list chunk. This may be due to a deployment mismatch. Error:", error);
    throw error;
  }),
) as DatatableListType;

export function DatatableList<TData extends DatatableRowData>({
  getRowPath,
  onRowClick,
  onRowHover,
  isRowSelected,
  config,
}: {
  getRowPath?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => string;
  onRowClick?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => void;
  onRowHover?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => void;
  isRowSelected?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => boolean;
  config?: {
    noInset?: boolean;
  };
}) {
  return (
    <Suspense fallback={<></>}>
      <LazyList<TData>
        getRowPath={getRowPath}
        onRowClick={onRowClick}
        onRowHover={onRowHover}
        isRowSelected={isRowSelected}
        config={config}
      />
    </Suspense>
  );
}
